import type { FaireProductEntity } from "../../entity_types/product";

export const p_f2g2jwcxa5: FaireProductEntity = {
  token: "p_f2g2jwcxa5",
  type: "product",
  name: "Rectangular Zirconia Tarot Card Necklace",
  brandToken: "b_xju99kcstz",
  brandName: "paperln",
  imageUrl:
    "https://cdn.faire.com/fastly/6dd66601f3994f9fc1cff2c377621251600365c390e59d39ac7857745943f0a4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/78d142e648ee588f74229aa36f559efa44ad1de1e59d44fcdd70da685a36b033.jpeg",
    "https://cdn.faire.com/fastly/01f37256076ab324b264c4c106d6e38e6c2cd796d8fb630961163073e0695b6e.jpeg",
    "https://cdn.faire.com/fastly/3e9ee39820f9062dbd23c25c6a521f217c8eabd8cffdd23aa8d882e33c6dc4a6.jpeg",
    "https://cdn.faire.com/fastly/7631b8a4c64215b9fe9fdc71dfe4f95eeb9736706f3124c84da8f443534f3bd4.jpeg",
    "https://cdn.faire.com/fastly/b5106e94cd4d7418180cc95316bcac68d781c8af2320237365e98712638974c5.jpeg",
    "https://cdn.faire.com/fastly/55c01bca53bf4996142a9f69665c51e53cf063ce1ecf915265ef36b325638d51.jpeg",
    "https://cdn.faire.com/fastly/bd15319a28b63d6f3b8270a152228fe5e68bb88990693e16914faa64c5e125e0.jpeg",
    "https://cdn.faire.com/fastly/b92fed2277ea5f6014ecbf8804e7b2473f34a69f6026df358eb180e1835dd585.jpeg",
    "https://cdn.faire.com/fastly/8743364065cdcbf34a04dcce0e3582f91b9d8c3de4caef047f648db394e7c7b5.jpeg",
    "https://cdn.faire.com/fastly/2aa1ee2126fedf93b50693d79af379d5f75de33900fc64bfdb64b70c7c5ddffd.jpeg",
    "https://cdn.faire.com/fastly/5a582aca4f835eee08d90fe0cf7473c33541a8a122a541df423d6aa13796ef7e.jpeg",
    "https://cdn.faire.com/fastly/a618189864a17591dbd6703ccea4378896e4d28ef51a1dbf7bc3aae6d6069eb7.jpeg",
    "https://cdn.faire.com/fastly/5521ac6f20f689715b050fd1fbf62e56723da3fcad0e6fc6fa212cfd83c545dc.jpeg",
    "https://cdn.faire.com/fastly/be1c5b38e1591ba569d3a16cff22c95a2934ed73133b6458090c28762e1a50de.jpeg",
    "https://cdn.faire.com/fastly/7cd7ffb0eb4502bc41fad0908d3b8858445e7f5e56393ba809588f25ad38c068.jpeg",
    "https://cdn.faire.com/fastly/a7e5740bd383e063344532dc9a84a08c0d16ba019ab7be80555784840170c652.jpeg",
    "https://cdn.faire.com/fastly/a49ab9232665afd900f8204896d7cdb789a2a9b588258746ad5eb71214ed53b7.jpeg",
    "https://cdn.faire.com/fastly/5a49155f33a1e572a37d0b761b8db96aff5244aa7d8247cef48a5cd21dbb3c21.jpeg",
    "https://cdn.faire.com/fastly/7bda90e2d6f30304467cc2686b789cb6855c165f9aebc638c7b773951a2fecec.jpeg",
    "https://cdn.faire.com/fastly/cbb2b1e88e8ff7291eb8c7a5b77fc9ba8fd6b17f6ba805965594373ebe52a55d.jpeg",
    "https://cdn.faire.com/fastly/39e59808c3fdf991dedc3c3796aa285a712da11cba17505f5241742e26462878.jpeg",
  ],
  priceDollars: 10.89,
  description:
    "Elevate your style with this exquisite Rectangular Zirconia Tarot Card Necklace, perfect for any occasion. \n\n- Features: \n  - Intricate tarot card design\n  - Sparkling zirconia accents\n  - Adjustable chain for a perfect fit\n\n- Materials: \n  - Durable and tarnish-resistant\n\n- Styling Suggestions: \n  - Pair with both casual and formal outfits\n  - Layer with other necklaces for a trendy look\n\n- Care Instructions: \n  - Avoid contact with water and chemicals\n  - Clean with a soft cloth to maintain shine\n\nA captivating piece that adds a touch of mystique to your jewelry collection.",
  tags: [],
  msrpDollars: 21.78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:31.309Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
